module.exports = __webpack_public_path__ + "img/88f9970.png";